import { TOGGLE_MODAL } from '../../../actions/entity';

export default (state = false, action) => {
  switch (action.type) {
    case TOGGLE_MODAL:
      return !state;
    default:
      return state;
  }
};

export const getOpen = state => state;